import * as React from 'react';
import styled from 'styled-components';

import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { IllustrationMagic } from '@doltech/ui/lib/figma/Illustration/IllustrationMagic/IllustrationMagic';

const LoadingContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 32px 16px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  height: 100%;
  padding: 32px 0;
`;

interface LoadingScreenProps {
  message?: string;
}

export const LoadingScreen = (props: LoadingScreenProps) => {
  const { message = 'Đang tải dữ liệu, bạn vui lòng chờ trong giây lát...' } = props;

  return (
    <Container className="loading-screen">
      <LoadingContent>
        <IllustrationMagic size={124} />
        <ResponsiveTypography.Paragraph variant="semi-bold/20-28" color="gray120" mt="24px">
          {message}
        </ResponsiveTypography.Paragraph>
      </LoadingContent>
    </Container>
  );
};
